export function PharmacyBrand() {
  return (
    <div className="pharmacy-brand">
      <span className="pharmacy-brand-mark">
        <img src="/assets/dashboard/pharmacy.svg" alt="" />
      </span>
      <div className="pharmacy-brand-text">
        <strong>Pare Pharmacy</strong>
        <span>SMART POS SYSTEM</span>
      </div>
    </div>
  )
}
